// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiKey: '777d1613-189a-4136-86ee-6b367cfb1793',
  baseAPIUrl: 'https://genesys-usa-dev.azurewebsites.net',
  // LH-49: "Redline Link" formula-URL field on File Attachments (fid differs per env: DEV 33, PROD 35)
  redlineLinkFieldId: 33
};
